const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Subcontratante autorizado',
    city: 'Cidade',
    state: 'Estado',
    country: 'País',
    noDealer: '** Sem subcontratantes autorizados disponíveis **',
    heading: 'Subcontratante autorizado',
    addDealerButton: '+ Adicionar subcontratante autorizado',
    cancel: 'CANCELAR',
    addSubcontractor: 'ADICIONAR SUBCONTRATANTE',
    searchContractor: 'PROCURAR SUBCONTRATANTE',
    show: 'A mostrar',
    to: 'para',
    of: 'de',
    delete: 'Eliminar',
    name: 'Nome',
    enabled: 'Ativado',
    disabled: 'Desativado',
    status: 'Estado',
    footer: 'Subcontratados autorizados'
  }
};

export default authorizedDealer;
